/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import notice from 'src/common/components/Notice';
import { usePagination } from 'src/hooks/usePagination';
import { structureAPI } from 'src/api/modules/structure';
import { download } from 'src/pages/Files/UpaloadFileMinos';

export const useStructure = () => {
	const [data, setData] = useState([]);
	const [loader, setLoader] = useState(false);

	const {
		pagination,
		handlePagination,
		currentPage,
		setCurrentPage,
		totalResults,
		setTotalResults,
	} = usePagination();

	const getAll = () => {
		structureAPI
			.getAllStrucutre(pagination, currentPage)
			.then((response) => {
				if (response.archivos && response.archivos.length > 0) {
					setData(
						response.archivos.map((item) => ({
							...item,
							fecha: new Date(item.fecha).toLocaleDateString(),
							hora: new Date(item.fecha).toLocaleString().split(',')[1],
						}))
					);
					setTotalResults(response.totalRegistros);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const onDownload = async (ruta) => {
		download(
			ruta.ruta,
			ruta.nombre,
			ruta.nombreUsuario,
			false,
			'Estructura ' + ruta.nombre,
			ruta.nombre
		);
	};

	useEffect(() => {
		if (!loader) {
			getAll();
		}
	}, [pagination, currentPage, loader]);

	return {
		data,
		handlePagination,
		setCurrentPage,
		totalResults,
		pagination,
		currentPage,
		setLoader,
		getAll,
		onDownload,
		loader,
	};
};
